export function testChargeMessage(state = null, action) {
    switch (action.type) {
        case 'test_charge_message':
            console.log(action.data);
            return action.data
        default:
            return state
    }
}